/* lib/geo.js */

/* Copyright 2026 - present Tikkl, Inc. */

/*
modification history
--------------------
01a,01feb26,mno  created.
*/

export const geo = {
  initialized: false,
};

export function initializeGeo(geoParams) {
  if (!geo.initialized) {
    Object.keys(geoParams).forEach((key) => {
      geo[key] = geoParams[key];
    });
    geo.initialized = true;
  }
}